import { FC } from "react";
import { useMutation } from "@tanstack/react-query";
import { resendInviteForTeamMember } from "api/landlord/landlord";
import { Button, ButtonSize, ButtonVariant } from "shared/components";
import { getAvatarInitials } from "utils/userUtils";
import { getErrorMessage } from "utils/error";
import { toast } from "react-toastify";

type Props = {
  user: {
    name: string;
    email: string;
    id: number;
  };
};

export const TeamMember: FC<Props> = ({ user }) => {
  const { mutate } = useMutation({
    mutationFn: () => {
      return resendInviteForTeamMember({ userId: user.id });
    },
    onSuccess: () => {
      toast.success(
        `A new invite has been sent to ${user.name}. Please ask them to check their email.`
      );
    },
    onError: (error) => {
      toast.error(getErrorMessage(error));
    }
  });

  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-4">
        <div className="flex h-10 w-10 items-center justify-center rounded-full border border-alpha-100 bg-primary-50 text-xs font-medium text-primary-500">
          {getAvatarInitials(user.name)}
        </div>
        <div>
          <p className="text-sm font-bold text-content-1000">{user.name}</p>
          <p className="text-xs text-content-300">{user.email}</p>
        </div>
      </div>
      <Button
        variant={ButtonVariant.BASE}
        size={ButtonSize.SM}
        onClick={() => mutate()}
      >
        Resend an invite
      </Button>
    </div>
  );
};
